import { render, staticRenderFns } from "./Mortality.vue?vue&type=template&id=3e716ca8&scoped=true"
import script from "./Mortality.vue?vue&type=script&lang=js"
export * from "./Mortality.vue?vue&type=script&lang=js"
import style0 from "./Mortality.vue?vue&type=style&index=0&id=3e716ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e716ca8",
  null
  
)

export default component.exports